import * as React from "react";
import { SVGProps } from "react";

const UnusSedLeo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 197 222"
    {...props}
  >
    <linearGradient
      id="a"
      x1={56.195}
      x2={56.195}
      y1={700.57}
      y2={798}
      gradientTransform="translate(-15.82 -616.04)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#f6e93d" />
      <stop offset={0.13} stopColor="#f8e330" />
      <stop offset={0.35} stopColor="#f7c730" />
      <stop offset={0.64} stopColor="#f59c2e" />
      <stop offset={0.98} stopColor="#eb5e2c" />
      <stop offset={1} stopColor="#eb5c2c" />
    </linearGradient>
    <path
      fill="url(#a)"
      d="M46.1 95.2h.1l1.7.6 1.6.6 1.7.5 1.6.7 1.7.6 1.6.6 1.7.6 1.6.6 1.6.6 1.6.6 1.7.6 1.6.7 1.7.5 1.6.6 1.7.6 1.6.7 1.7.6 1.6.5 1.6.6 1.7.7 1.7.6V84.5H43.9l-1.6.8-3.8 2-3.9 2.1-3.9 1.9-3.7 2-3.9 2.1-3.9 1.9-3.8 2.1-3.9 2-3.8 1.9-3.8 2.1-3.5 1.8-.4 57.3 3.9 2.7 3.8 2.7 3.8 2.6 3.9 2.8 3.8 2.7 3.9 2.7 1.7 1.3 2.2-2.8 3.7-5 .4-.5-.4-.3-3.7-2.7-3.9-2.7-3.9-2.7-3.8-2.7-3.9-2.8-1-.6.3-46.4.7-.4 3.9-1.9 3.8-1.9 3.9-1.9 3.9-1.9 3.7-2 3.9-1.9 3.9-1.8 3.8-2z"
    />
    <linearGradient
      id="b"
      x1={94.485}
      x2={94.485}
      y1={757.28}
      y2={838.23}
      gradientTransform="translate(-15.82 -616.04)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#f6e93d" />
      <stop offset={0.13} stopColor="#f8e330" />
      <stop offset={0.35} stopColor="#f7c730" />
      <stop offset={0.64} stopColor="#f59c2e" />
      <stop offset={0.98} stopColor="#eb5e2c" />
      <stop offset={1} stopColor="#eb5c2c" />
    </linearGradient>
    <path
      fill="url(#b)"
      d="m112.3 204.5-3.2 1.3-3.6 1.5-3.6 1.4-3.6 1.5-1.6.6-1.9-.9-3.6-1.9-3.6-1.7-3.5-1.9-3.6-1.8-3.6-1.7-3.6-1.9-3.6-1.8-3.6-1.8-3.6-1.8-3.6-1.9-3.4-1.7-3.6-1.8-.4-.2v-46.8H41.1v53.2l3.6 1.7 3.6 1.8 3.6 1.9 3.6 1.7 3.4 1.9 3.6 1.8 3.6 1.8 3.6 1.8 3.6 1.8 3.6 1.8 3.6 1.8 3.6 1.9 3.5 1.7 3.6 1.9 3.6 1.7 1.4.8 2.1-1 3.6-1.3 3.6-1.5 3.6-1.5 3.5-1.4 3.6-1.4-3.6-9z"
    />
    <linearGradient
      id="c"
      x1={139.615}
      x2={139.615}
      y1={733.63}
      y2={824.07}
      gradientTransform="translate(-15.82 -616.04)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#f6e93d" />
      <stop offset={0.13} stopColor="#f8e330" />
      <stop offset={0.35} stopColor="#f7c730" />
      <stop offset={0.64} stopColor="#f59c2e" />
      <stop offset={0.98} stopColor="#eb5e2c" />
      <stop offset={1} stopColor="#eb5c2c" />
    </linearGradient>
    <path
      fill="url(#c)"
      d="m176.2 139.5.2 22-.9.8-6.1 4.2-6.1 4.4-6.1 4.4-6.1 4.3-6.1 4.3-6 4.4-6.1 4.3-3.6 2.6-2.5-1.9-6-4.7-6.1-4.6-6.1-4.7-6-4.6-1.1-.8v-23.7l1.1-1 6-6.4 6.1-6.3 6.1-6.4 6-6.3 5.9-6.2H60l6.1 6.4 6 6.3 6.1 6.3 6.1 6.4 6 6.3.9.9v28.7l5.2 4.1 6.2 4.7 6 4.6 6.1 4.7 6.1 4.6 6 4.7 2.2 1.7 3.9-2.8 6.1-4.2 6-4.4 6.1-4.4 6.1-4.2 6.1-4.4 6.1-4.4 6.1-4.2 6.1-4.4 5-3.7 1-27-6-.2z"
    />
    <linearGradient
      id="d"
      x1={66.615}
      x2={66.615}
      y1={633.97}
      y2={704.35}
      gradientTransform="translate(-15.82 -616.04)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#f6e93d" />
      <stop offset={0.13} stopColor="#f8e330" />
      <stop offset={0.35} stopColor="#f7c730" />
      <stop offset={0.64} stopColor="#f59c2e" />
      <stop offset={0.98} stopColor="#eb5e2c" />
      <stop offset={1} stopColor="#eb5c2c" />
    </linearGradient>
    <path
      fill="url(#d)"
      d="M9.9 88.3h.7l.1-29.4 3.9-2.5 4.9-2.9 4.8-2.9 4.8-3 4.8-2.9 4.9-3 4.7-2.9 4.9-2.9 4.8-3 4.9-3h.1l4.6 2.7 4.9 2.7 4.8 2.8 4.8 2.7 4.8 2.7 4.8 2.7 4.8 2.8 4.7 2.7.2-.4 4.8-8.7-4.8-2.8-4.9-2.7-4.8-2.7-4.8-2.7-4.8-2.8-4.8-2.7-4.8-2.7-4.9-2.8-4.7-2.7-.2-.1-4.7 2.8-4.8 3-4.9 3-4.7 3-4.9 2.9-4.8 2.9-4.8 3-4.8 2.9-4.9 3-4.7 2.9L5 50.2.4 53.1.2 88.2H5z"
    />
    <linearGradient
      id="e"
      x1={187.26}
      x2={187.26}
      y1={657.82}
      y2={764.75}
      gradientTransform="translate(-15.82 -616.04)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#f6e93d" />
      <stop offset={0.13} stopColor="#f8e330" />
      <stop offset={0.35} stopColor="#f7c730" />
      <stop offset={0.64} stopColor="#f59c2e" />
      <stop offset={0.98} stopColor="#eb5e2c" />
      <stop offset={1} stopColor="#eb5c2c" />
    </linearGradient>
    <path
      fill="url(#e)"
      d="m197.9 61.4-2.5-2-2.5-2-2.5-2.1-2.5-2-2.5-2-2.6-2-2.5-2-2.5-2-2.6-2.1-1.9-1.4-.7.8-2.5 3.1-2.5 3.2-.7.8.7.7 2.5 2.1 2.5 2.1 2.6 2.1 2.6 2.1 2.5 2.2 2.5 2.1 2.6 2.1 1.2 1 .1 47.3-1.3.9-2.6 1.6-2.5 1.6-2.5 1.6-2.6 1.6-2.6 1.6-2.5 1.6-2.5 1.6-2.5 1.6-2.5 1.6-2.5 1.6-2.6 1.6-2.5 1.6-2.5 1.6-2.5 1.6-2.6 1.6-2.5 1.6 2.5 4 2.6 4 .4.7 2.1-1.3 2.5-1.5 2.5-1.6 2.6-1.5 2.5-1.7 2.5-1.5 2.5-1.6 2.5-1.5 2.5-1.6 2.6-1.5 2.6-1.7 2.5-1.5 2.5-1.6 2.6-1.5 2.5-1.6 2.5-1.5 2.5-1.7 2.5-1.5 2.5-1.6z"
    />
    <linearGradient
      id="f"
      x1={128.46}
      x2={128.46}
      y1={616.04}
      y2={726.07}
      gradientTransform="translate(-15.82 -616.04)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#f6e93d" />
      <stop offset={0.13} stopColor="#f8e330" />
      <stop offset={0.35} stopColor="#f7c730" />
      <stop offset={0.64} stopColor="#f59c2e" />
      <stop offset={0.98} stopColor="#eb5e2c" />
      <stop offset={1} stopColor="#eb5c2c" />
    </linearGradient>
    <path
      fill="url(#f)"
      d="M115.4 89.6V110l.8-.3 3.4-1.3 3.4-1.4 3.3-1.3 3.4-1.4 3.4-1.4 3.3-1.3 3.4-1.4 3.4-1.3 3.3-1.4 3.4-1.3 3.3-1.4V32.9l-3.8-2.4-3.9-2.2-3.9-2.2-3.8-2.4-3.9-2.2-3.9-2.2-3.8-2.3-3.9-2.3-3.8-2.3-3.9-2.2-3.9-2.3-3.8-2.3-3.8-2.2-3.9-2.2L97.1 0l-1.8 1-3.9 2.1-3.9 2-3.7 2.2-3.9 2.1-3.9 2-3.9 2.2 3.9 2.2 3.9 2.2 2.4 1.5 1.5-.8 3.7-2 3.9-2.1 3.9-2 1.5-.8 2.4 1.4 3.9 2.2 3.8 2.2 3.8 2.3 3.9 2.3 3.9 2.2 3.8 2.3 3.9 2.3 3.8 2.2 3.9 2.2 3.9 2.4 3.8 2.2 1.3.7v45.6h-27.3"
    />
    <linearGradient
      id="g"
      x1={150.08}
      x2={150.08}
      y1={700.41}
      y2={726.1}
      gradientTransform="translate(-15.82 -616.04)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#f6e93d" />
      <stop offset={0.13} stopColor="#f8e330" />
      <stop offset={0.35} stopColor="#f7c730" />
      <stop offset={0.64} stopColor="#f59c2e" />
      <stop offset={0.98} stopColor="#eb5e2c" />
      <stop offset={1} stopColor="#eb5c2c" />
    </linearGradient>
    <path fill="url(#g)" d="m115.4 110 37.8-15.2-37.8-10.5" />
    <linearGradient
      id="h"
      x1={78.903}
      x2={87.063}
      y1={719.687}
      y2={697.267}
      gradientTransform="translate(-15.82 -616.04)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#f6e93d" />
      <stop offset={0.13} stopColor="#f8e330" />
      <stop offset={0.35} stopColor="#f7c730" />
      <stop offset={0.64} stopColor="#f59c2e" />
      <stop offset={0.98} stopColor="#eb5e2c" />
      <stop offset={1} stopColor="#eb5c2c" />
    </linearGradient>
    <path fill="url(#h)" d="M80.8 110V84.7L46.2 95l34.6 14.9" />
  </svg>
);

export default UnusSedLeo;
